export {
  default as grotto,
  ReactComponent as Grotto,
} from '@assets/icons/features-and-amenities/grotto.svg'    
